export default "/fonts/enchanted_land-webfont.woff?04a4e6292cc3d80bb901720ed254a12b";